import { styled } from "@vitality-ds/system";
import BaseClearButtonStyles from "./styles/BaseIsMultiWrapper.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseIsMultiWrapper = styled("div", BaseClearButtonStyles);